module.exports = __webpack_public_path__ + "static/media/phoenix.00d9d640.png";